import { defineStore } from 'pinia';

export const useCommonStore = defineStore('common', {
  state: () => ({
    loading: 0,
    transitioning: false,
    layoutName: '',
    paymentCompanyId: null as number | null,
    // Sonuç sayfasındaki işlemin firma adı; üst bant marka için işlemin firmasını kullanır.
    paymentCompanyName: null as string | null
  }),

  getters: {
    getLoading: (state) => state.loading,
    getTransitioning: (state) => state.transitioning,
    getLayout: (state) => state.layoutName,
    getPaymentCompanyId: (state) => state.paymentCompanyId
  },

  actions: {
    setLayout(layout: string) {
      this.layoutName = layout;
    },

    setPaymentCompanyId(companyId: number | null) {
      this.paymentCompanyId = companyId;
    },

    setPaymentCompanyName(companyName: string | null) {
      this.paymentCompanyName = companyName;
    },
    
    setLoading(loading: number) {
      this.loading = loading;
    },
    
    increaseLoading() {
      if (this.loading < 0) {
        this.loading = 0;
      }
      this.loading = this.loading + 1;
    },
    
    decreaseLoading() {
      if (this.loading <= 0) {
        this.loading = 0;
      }
      else this.loading = this.loading - 1;
    },
    

    setTransitionStatus(transitioning: boolean) {
      this.transitioning = transitioning;
    }
  }
}); 
